/* eslint-disable jsx-a11y/label-has-associated-control */
import { useController } from 'react-hook-form'
import InputMask from 'react-input-mask'
import tw from 'twin.macro'

import Caption from '../caption'
import SubBody from '../sub-body/sub-body'

export const MaskedInput = ({ isRequired = false, ...props }) => {
  const {
    field: { value, onChange, name },
    fieldState: { invalid, error }
  } = useController({ name: props.name, control: props.control, shouldUnregister: false })

  const onChangeHandler = value => {
    const formattedValue = value.target.value.replace(/[^\d+]/g, '')
    onChange(formattedValue)
  }

  return (
    <span css={[tw`flex flex-col space-y-1 mt-1 min-w-0 max-w-full w-full relative`, props.disabled && tw`opacity-50`]}>
      {props.label && (
        <label htmlFor={name} tw='ml-s13 text-sm'>
          <SubBody>
            <span>
              {props.label}
              {isRequired && <span tw='text-red-500'>*</span>}
            </span>
          </SubBody>
        </label>
      )}
      <span tw='relative' css={[props.twStyle]}>
        <InputMask
          id={name}
          name={name}
          value={value || ''}
          mask={props.mask}
          maskChar=''
          autoComplete='off'
          type={props.type}
          inputMode={props.inputMode}
          placeholder={props.placeholder}
          onChange={onChangeHandler}
          disabled={props.disabled}
          css={[
            tw`rounded-s14 bg-input outline-none text-primary font-bold placeholder-input
              placeholder-shown:font-normal px-5 py-s13 w-full border border-transparent
              focus:border-input-active disabled:cursor-not-allowed text-s14`,
            props.icon && tw`pl-10`,
            invalid && tw`border-input-invalid focus:border-input-invalid`
          ]}
        />
        <span tw='absolute left-2 inset-y-2'>{props.icon}</span>
        <span tw='absolute text-secondary right-5 inset-y-1/4'>{props.affix}</span>
      </span>

      {(props.subText || invalid) && (
        <span tw='ml-s13 text-left leading-3 bottom-4' css={[props.errorStyle]}>
          <Caption twStyle={invalid ? tw`text-error` : tw`text-secondary`}>
            {props.subText || error?.message || ''}
          </Caption>
        </span>
      )}
    </span>
  )
}
